/** Who is offered a project's Site Register: the same people the API lets
 *  in (src/supabase/functions/server/lib/site_register_access.ts). The API
 *  still decides; this only decides whether to show the tab and the
 *  Overview's "View register" link. */

/** users.supervisor_role values for the people who run a site. */
export const SITE_SUPERVISOR_ROLES = ['site_supervisor', 'foreman', 'site_manager'] as const;

/** Whether a user is a site supervisor. The signed-in user's profile row
 *  arrives snake_cased (supervisor_role) while DataService's copy is
 *  camelCased (supervisorRole), so both spellings are read. */
export function isSiteSupervisor(user: unknown): boolean {
  if (!user || typeof user !== 'object') return false;
  const record = user as { supervisorRole?: unknown; supervisor_role?: unknown };
  const role = record.supervisorRole ?? record.supervisor_role;
  return typeof role === 'string' && (SITE_SUPERVISOR_ROLES as readonly string[]).includes(role);
}

/** Once the project's grants are confirmed (which means the person can open
 *  the project at all): anyone holding canManageTeam, as internal staff
 *  always do, or a site supervisor. */
export function canOpenSiteRegister(
  permissions: { canManageTeam?: boolean } | null | undefined,
  siteSupervisor: boolean,
): boolean {
  if (!permissions) return false;
  return permissions.canManageTeam === true || siteSupervisor;
}
